import { Icon } from "./icons";

/** Props Interface */
interface LinkIconProps {
	isExternal?: boolean;
	icon: React.ReactNode;
}

export function LinkIcon({ isExternal, icon }: LinkIconProps) {
	if (isExternal) {
		return <Icon name="ExternalLink" />;
	}
	return icon;
}
